import React, { memo, useCallback, useEffect, useState, useRef } from 'react'
import { FixedSizeList as List } from 'react-window'
import CatalogItem from './CatalogItem'
import { emptyGuid } from '../../../utils/emptyGuid'
import { t } from 'i18next'
import styled from 'styled-components'

const StyledContainer = styled.div`
  max-width: 100vw;
  overflow-x: hidden;
`
const BigDataList = memo(({ bigData, ...rest }) => {
  const [bigDataArray, setBigDataArray] = useState([])
  const [width, setWidth] = useState(window.innerWidth)
  const [listWidth, setListWidth] = useState(650)
  const containerRef = useRef(null)
  const listRef = useRef(null)

  useEffect(() => {
    const updateWidth = () => {
      const newWidth = window.innerWidth
      setWidth(newWidth)

      if (newWidth < 426) {
        setListWidth(0) // Hide list
      } else if (newWidth < 688) {
        setListWidth(420)
      } else {
        setListWidth(containerRef.current?.offsetWidth || 650)
      }

      if (listRef.current?.resetAfterIndex) {
        listRef.current.resetAfterIndex(0, true)
      }
    }

    updateWidth()

    window.addEventListener('resize', updateWidth)
    return () => window.removeEventListener('resize', updateWidth)
  }, [])

  const getDimensionChildren = useCallback((parentId, dimensions, level) => {
    let result = []
    let newLevel = ++level
    let levelDimensions = dimensions.filter((d) => d.parentId === parentId)
    for (let levelD of levelDimensions) {
      levelD.level = newLevel
      if (levelD.open) {
        let articles = Object.values(levelD.articles).map((a) => {
          a.level = newLevel + 1
          return a
        })
        result.push(
          levelD,
          ...getDimensionChildren(levelD.id, dimensions, newLevel),
          ...articles
        )
      } else {
        result.push(levelD)
      }
    }
    return result
  }, [])

  const flattenBigData = useCallback(
    (obj) => {
      let templatesArr = Object.values(obj).map((catalog) => {
        let dimensionList = []
        let visibleArticles = []
        if (catalog.open) {
          let dimensions = Object.values(catalog.dimensions)
          dimensionList = getDimensionChildren(emptyGuid, dimensions, 0)
          visibleArticles = Object.values(catalog.articles)
        }
        let preparedTemplate = { ...catalog, type: 'catalog' }
        return [preparedTemplate, ...dimensionList.flat(), ...visibleArticles]
      })
      return templatesArr.flat()
    },
    [getDimensionChildren]
  )

  useEffect(() => {
    if (bigData) {
      setBigDataArray(flattenBigData(bigData))
    }
  }, [bigData, flattenBigData])

  if (width < 476) {
    return (
      <div
        style={{
          textAlign: 'center',
          color: '#555',
          overflow: 'hidden',
        }}
      >
        <strong>
          {t('catalogsAdministration:smallDeviceInfo1')}
          <br />
          {t('catalogsAdministration:smallDeviceInfo2')}
        </strong>
      </div>
    )
  }

  return (
    <StyledContainer>
      <div ref={containerRef} style={{ width: '100%', maxWidth: '100%' }}>
        <List
          ref={listRef}
          height={800}
          itemCount={bigDataArray.length}
          itemSize={32}
          width={listWidth}
        >
          {({ index, style }) => (
            <div style={style}>
              <CatalogItem
                key={bigDataArray[index].id}
                index={index}
                arrayItem={bigDataArray[index]}
                {...rest}
              />
            </div>
          )}
        </List>
      </div>
    </StyledContainer>
  )
})

export default BigDataList
